import { render, staticRenderFns } from "./linkem-checkbox.vue?vue&type=template&id=8de45c88&"
import script from "./linkem-checkbox.vue?vue&type=script&lang=js&"
export * from "./linkem-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports